import React, { useEffect, useState } from "react";
import {
    useParams,
    useHistory,
    useLocation
} from "react-router-dom";

// import action
import {
    sentVerifyLink,
    verifyNewEmail,
    confirmMail
} from '../actions/editProfile';

import { toastAlert } from "../lib/toastAlert";
import Loader from "./Loader";

// import lib
// import { toastAlert } from "../lib/toastAlert";

const EmailVerification = (props) => {
    const { authToken } = useParams();
    const history = useHistory();
    const location = useLocation();

    // state
    const [page, setPage] = useState('loading')

    const verifOldEmail = async () => {
        const data = {
            token: authToken
        }
        const verify = await sentVerifyLink(data);
        if (verify?.status) {
            history.push("/login");
            toastAlert("success", verify?.message, "verifOldEmail");
        } else {
            setPage('error');
            toastAlert("error", verify?.error, "verifOldEmail");
        }
    }

    const verifNewEmail = async () => {
        const data = {
            token: authToken
        }
        const newEmail = await verifyNewEmail(data);
        if (newEmail?.status) {
            history.push("/login");
            toastAlert("success", newEmail?.message, "verifNewEmail");
        } else {
            setPage('error');
            toastAlert("error", newEmail?.error, "verifNewEmail");
            history.push("/login");
        }
    }

    const emailActivation = async () => {
        const data = {
            token: authToken
        }

        const { status, message,error } = await confirmMail(data);
        if (status == true) {
            history.push("/login");
            toastAlert('success', message, 'emailActivation');
        } else if (status == false) {
            history.push("/login");
            toastAlert('error', message, 'emailActivation');
        }
        else {
            setPage('error');
        }
    }

    useEffect(() => {
        let pathname = location.pathname;
        
        if (pathname == '/verify-old-email/' + authToken) {
            verifOldEmail();
        } else if (pathname == '/verify-new-email/' + authToken) {
            verifNewEmail();
        }
        else if (pathname == '/email-verification/' + authToken) {
            emailActivation()
        }
    }, [authToken])

    return (
        <>
            {
                page == 'loading' && (
                    <div
                        className="d-flex flex-column align-items-center justify-content-center"
                        style={{ height: '100vh' }}
                    >
                        <Loader />
                    </div>
                )
            }
            {
                page == 'error' && <p>Invalid verification link.</p>
            }
        </>
    )


}

export default EmailVerification;